import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const VideoCameraOnIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      opacity="0.2"
      d="M2.625 6.5625H16.625C17.5533 6.5625 18.4435 6.93125 19.0999 7.58763C19.7563 8.244 20.125 9.13424 20.125 10.0625V20.5625C20.125 20.7946 20.0328 21.0171 19.8687 21.1812C19.7046 21.3453 19.4821 21.4375 19.25 21.4375H5.25C4.32174 21.4375 3.4315 21.0688 2.77513 20.4124C2.11875 19.756 1.75 18.8658 1.75 17.9375V7.4375C1.75 7.20544 1.84219 6.98288 2.00628 6.81878C2.17038 6.65469 2.39294 6.5625 2.625 6.5625Z"
      fill="white"
    />
    <path
      d="M2.625 6.5625H16.625C17.5533 6.5625 18.4435 6.93125 19.0999 7.58763C19.7563 8.244 20.125 9.13424 20.125 10.0625V20.5625C20.125 20.7946 20.0328 21.0171 19.8687 21.1812C19.7046 21.3453 19.4821 21.4375 19.25 21.4375H5.25C4.32174 21.4375 3.4315 21.0688 2.77513 20.4124C2.11875 19.756 1.75 18.8658 1.75 17.9375V7.4375C1.75 7.20544 1.84219 6.98288 2.00628 6.81878C2.17038 6.65469 2.39294 6.5625 2.625 6.5625V6.5625Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.125 12.25L26.25 8.75V19.25L20.125 15.75"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
